<div class="ag-views-toolbar">
  @if (visoes?.length) {
    <div class="flex align-items-center">
      @if (visoesFixas.length) {
        <p-selectButton
          size="small"
          optionLabel="nm_visao"
          [options]="visoesFixas"
          [ngModel]="visaoSelecionada"
          (onChange)="changeVisao($event.value)"
        ></p-selectButton>
      }
      @if (visoesNaoFixas.length) {
        <p-select
          size="small"
          placeholder="Mais Visões"
          optionLabel="nm_visao"
          [options]="visoesNaoFixas"
          [ngModel]="visaoSelecionada"
          (onChange)="changeVisao($event.value)"
        ></p-select>
      }
      <i
        class="pi pi-info-circle text-primary cursor-pointer ml-1"
        (click)="op.toggle($event)"
        [attr.data-tooltip]="viewTooltipKey"
      ></i>
    </div>
  }
  <p-popover #op>
    <ng-template pTemplate="content">
      <div class="tooltip-overlay" [innerHTML]="viewTooltipHtml | safeHtml"></div>
      @if (viewTooltipUrl && (suporteVisible$ | async)) {
        <div class="mt-4">
          <a class="text-primary" [href]="viewTooltipUrl" target="_blank" rel="noopener">
            Documentação
            <i class="pi pi-external-link text-sm ml-1"></i>
          </a>
        </div>
      }
      @if (podeEditarOrientacoes) {
        <div class="mt-2 text-sm">
          <a pTooltip="Editar este conteúdo" tooltipPosition="bottom" class="link" href="{{ orientacoesEditUrl }}" target="_blank" rel="noopener">
            Editar
          </a>
        </div>
      }
    </ng-template>
  </p-popover>
</div>
